import _ from 'lodash';

export const CALENDAR_COLUMNS_NUMBER = 7;

export const CALENDAR_CELL_TYPES = {
  DAY: 'day',
  EMPTY: 'empty',
  DAY_BEFORE: 'dayBefore',
  DAY_AFTER: 'dayAfter',
};

export const CALENDAR_THEMES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  THIRD: 'third',
};

export const CALENDAR_SOURCES = {
  PROPERTY: 'property',
  SCHEDULE: 'schedule',
};

export const CALENDAR_DATA_DATE_KEY_FORMAT = 'YYYY-MM-DD';

export const CALENDAR_WORKFLOW_GROUP = 'WorkflowGroup';

export const CALENDAR_SINGLE_TASK = 'SingleTask';

export const SINGLE_TASK_LIFE_STATUS = {
  ASSIGNED: 'assigned',
  FINISHED: 'finished',
  IN_PROGRESS: 'in_progress',
  OVERDUE: 'overdue',
  SCHEDULED: 'scheduled',
  UNASSIGNED: 'unassigned',
};

export const SCHEDULE_TYPE = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

export const SCHEDULE_CELL_TYPE = {
  DATA: 'data',
  EXPAND: 'expand',
  HEADING: 'heading',
  SUBJECT: 'subject',
};

export const SCHEDULE_MODE = {
  DAILY: 'day',
  MOBILE: 'mobile',
  MONTHLY: 'month',
  WEEKLY: 'week',
};

export const SCHEDULE_SUBJECT = {
  PROPERTY: 'property',
  USER: 'user',
  USER_PLANNING: 'user_planning',
};

export const SCHEDULE_DATE_OPERATION = {
  ADD: 'add',
  SUBTRACT: 'subtract',
};

export const SCHEDULE_DATE_MODIFIER = {
  DAILY: 1,
  FULL_WEEK: 6,
  WEEKLY: 7,
};

export const SCHEDULE_MODALS_NAMES = {
  NONE: null,
  RESERVATION_DETAILS: 'reservationDetails',
  TASK_CREATE: 'taskCreate',
  TASK_DETAILS: 'taskDetails',
  TASK_DETAILS_PLANNING: 'taskDetailsPlanning',
  TASK_DRAFT_DETAILS: 'taskDraftDetails',
  TASK_DRAFT_DETAILS_PLANNING: 'taskDraftDetailsPlanning',
  WORKFLOW_DETAILS: 'workflowDetails',
  DRAFT: 'draft',
  FILTERS: 'filters',
};

export const SCHEDULE_DAILY_TIME_RANGE = {
  'col1-8-10am': {
    from: 8,
    to: 10,
    suffix: 'AM',
  },
  'col2-10-12pm': {
    from: 10,
    to: 12,
    suffix: 'PM',
  },
  'col3-12-2pm': {
    from: 12,
    to: 14,
    suffix: 'PM',
  },
  'col4-2-4pm': {
    from: 14,
    to: 16,
    suffix: 'PM',
  },
  'col5-4-6pm': {
    from: 16,
    to: 18,
    suffix: 'PM',
  },
  'col6-6-8pm': {
    from: 18,
    to: 20,
    suffix: 'PM',
  },
};

export const SCHEDULE_SUBJECT_HEADINGS = {
  [SCHEDULE_SUBJECT.PROPERTY]: 'properties',
  [SCHEDULE_SUBJECT.USER]: 'users',
};

export const SCHEDULE_ALL_DAY_CELL_KEY = 'col0-allDayCell';

export const SCHEDULE_ROUTE_BASE = 'schedule';

export const SCHEDULE_ROUTE_DATE_FORMAT = 'YYYY-MM-DD';

export const SCHEDULE_DAILY_COLUMN_FORMAT = 'YYYY-MM-DD hh';

export const SCHEDULE_DAILY_COLUMN_PRECISE_FORMAT = 'YYYY-MM-DD hh:mm';

export const SCHEDULE_TASKS_SORT_MOMENT_FORMAT = 'YYYYMMDDHHmm';

export const SCHEDULE_UNASSIGNED_ID = 'unassigned';

export const SCHEDULE_TASK_TIME_DURATION = 2;

export const SCHEDULE_DAILY_TIME_OFFSET_PRECISION = 15;

export const singleTaskLifeStatuses = _.values(SINGLE_TASK_LIFE_STATUS);

export const scheduleCellTypes = _.values(SCHEDULE_CELL_TYPE);

export const scheduleModes = _.values(SCHEDULE_MODE);

export const scheduleDailyTimeRanges = _.values(SCHEDULE_DAILY_TIME_RANGE);

export const scheduleSubjects = _.values(SCHEDULE_SUBJECT);
